<mat-form-field [id]="id">
  <input mdInput disabled [value]="(date.begin | date: format) + (date.end != null ? ' to ' : '') + (date.end  ? (date.end | date : format) : '')" />
  <input [value]="date" matInput [hidden]="true" [satDatepicker]="picker" [placeholder]="placeholder" (dateChange)="onChange($event)" />
  <sat-datepicker-toggle matSuffix [for]="picker"></sat-datepicker-toggle>
  <sat-datepicker [rangeMode]="true" #picker></sat-datepicker>
</mat-form-field>